import axios from 'axios'
import {ProductModel, ShopModel} from './Models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_SEARCH_URL = `${API_URL}/get_searches`
export const GET_VIP_SHOP_URL = `${API_URL}/get_vip_shops`
export const GET_FOLLOWED_URL = `${API_URL}/get_followed_products`
export const CONTACT_REQUEST_URL = `${API_URL}/contact-requests`

export function getSearches(data: any) {
  return axios.post<ProductModel[]>(GET_SEARCH_URL, data)
}

export function getVipShops() {
  return axios.post<ShopModel[]>(GET_VIP_SHOP_URL, {})
}

export function getFollowedProducts() {
  return axios.post<ProductModel[]>(GET_FOLLOWED_URL, {})
}

// Contact Requests
export function createContactRequest(data: {
  name: string
  email: string
  mobile: string
  subject: string
  message: string
}) {
  return axios.post(CONTACT_REQUEST_URL, data)
}
